import React from 'react'
import dayjs, { Dayjs } from 'dayjs'
import DateFormat from '../../store/types/enums/DateFormat'
import { User } from '../../store/types'
import { WorkHoursFilteredHistoryRows } from './WorkHoursFilteredHistoryRows'
import ModificationHistoryBase from '../ModificationHistory/ModificationHistoryBase'
import { t } from 'i18next'
import { History } from '../../store/redux/reducers/auditSlice'
import parseJsonSafe from '../Schedule/parseJsonSafe'

interface WorkHoursHistoryProps {
  selectedDate: Dayjs
  onLeaveButtonClick: () => void
  selected: User | null
}

const WorkHoursModificationHistoryComponent: React.FC<WorkHoursHistoryProps> = ({
  selectedDate,
  onLeaveButtonClick,
  selected,
}) => {
  const filterFn = (item: History, selectedDate: Dayjs) => {
    const newRecord = parseJsonSafe(item.newValue)
    const oldRecord = parseJsonSafe(item.oldValue)
    const entryDate = newRecord?.date || oldRecord?.date
    if (entryDate) return dayjs(entryDate).isSame(selectedDate, 'month')
    return dayjs(item.createdAt).isSame(selectedDate, 'month')
  }

  const renderRows = (date: string, filteredAuditData: History[]) => {
    const rowsForDate = filteredAuditData.filter(
      it => dayjs(it.createdAt).format(DateFormat.DayTwoMonthNameYear) === date
    )
    return <WorkHoursFilteredHistoryRows filteredAuditData={rowsForDate} date={date} />
  }

  return (
    <ModificationHistoryBase
      selected={selected}
      selectedDate={selectedDate}
      onLeaveButtonClick={onLeaveButtonClick}
      tableName="work_hours"
      title={t('page.modification.historyTitle')}
      filterFn={filterFn}
      renderRows={renderRows}
    />
  )
}
export default WorkHoursModificationHistoryComponent
